import { IJsonQuery } from '@cian/api-models/common/json_query';

import * as React from 'react';
import { useSelector } from 'react-redux';

import { IReduxState } from '../../types/redux/store';
import { isOfficeRentSearch } from '../../utils/isOfficeRentSearch';
import { ApplicationContext } from '../../reactContext/applicationContext';

import { CoworkingHelper as CoworkingHelperComponent } from './CoworkingHelper';

const LOCAL_STORAGE_COWORKING_HELPER_ITEM = 'isCoworkingHelperClosed';

interface ICoworkingHelper {
  className?: string;
}

export const CoworkingHelper: React.FC<ICoworkingHelper> = props => {
  const { logger } = React.useContext(ApplicationContext);
  const jsonQuery = useSelector<IReduxState, IJsonQuery>(state => state.filters.jsonQuery);
  const isCoworkingHelperVisible = useSelector<IReduxState, boolean>(state => state.isCoworkingHelperVisible);
  const [isOpen, setOpen] = React.useState(false);

  const isOfficeSearch = isOfficeRentSearch(jsonQuery);

  React.useEffect(() => {
    try {
      const isCoworkingHelperClosed = sessionStorage.getItem(LOCAL_STORAGE_COWORKING_HELPER_ITEM);

      if (isCoworkingHelperClosed !== 'true') {
        setOpen(isOfficeSearch);
      }
    } catch (error) {
      logger.warning(error, {
        description: 'Была совершена попытка чтения из sessionStorage',
        message: 'Ошибка при чтении из sessionStorage',
        domain: 'CoworkingHelper: useEffect',
      });
    }
  }, [isOfficeSearch, logger]);

  const handleOutside = React.useCallback(() => {
    try {
      sessionStorage.setItem(LOCAL_STORAGE_COWORKING_HELPER_ITEM, 'true');
    } catch (error) {
      logger.warning(error, {
        description: 'Была совершена попытка записи в sessionStorage',
        message: 'Ошибка при чтении из sessionStorage',
        domain: 'CoworkingHelper: handleOutside',
      });
    } finally {
      setOpen(false);
    }
  }, [logger]);

  if (!isOpen || !isCoworkingHelperVisible) {
    return null;
  }

  return <CoworkingHelperComponent {...props} onOutside={handleOutside} />;
};

CoworkingHelper.displayName = 'CoworkingHelperContainer';
